import {mapState,mapActions} from "pinia";
import {Bundle, EquipmentOffering} from "../pages/application/equipment_pricing/entities";
import * as types from "../stores/constants";
import {Document} from "../entities";
import useApplicationStore from "../stores/application_module";

const STANDALONE_SERVICE = "STANDALONE_SERVICE";
const ACCESSORY = "ACCESSORY";
const GLOBAL_FEATURE = "GLOBAL_FEATURE";
const SPECIAL_OFFER = "SPECIAL_OFFER";
const THIRD_PARTY_EQUIPMENT = "THIRD_PARTY_EQUIPMENT";
const TALECH_SERVICE = "TALECH_SERVICE";
const FASTER_PAYMENT = "FASTER_PAYMENT";
const AMEX_SERVICE = "AMEX_SERVICE";
const CENTRAL_CLEARING = "CENTRAL_CLEARING";
const ELAVON_GATEWAY = "ELAVON_GATEWAY";

const SERVICE_CHARGE_ITEM_FEE = '1';   //used like service item
const SERVICE_CHARGE_ITEM_BILLING = '2';  //used like billing plan

const SERVICE_API_CODE_ELECTRONIC_STATEMENT = "electronicStatement";
const TALECH_SERVICE_LOGIC = {
    fakeSkuTalechStarterRegisterRestaurant: {
        is_editable_quantity: false,
        is_editable_price: true
    },
    fakeSkuTalechStarterRegisterRetail: {
        is_editable_quantity: false,
        is_editable_price: true
    },
    fakeSkuTalechStandardMainRegisterResturant: {
        is_editable_quantity: false,
        is_editable_price: true
    },
    fakeSkuTalechStandardMainRegisterRetail: {
        is_editable_quantity: false,
        is_editable_price: true
    },
    fakeSkuTalechPremiumMainRegisterResturant : {
        is_editable_quantity: false,
        is_editable_price: true
    },
    fakeSkuTalechPremiumMainRegisterRetail : {
        is_editable_quantity: false,
        is_editable_price: true
    },

    fakeSkuTalechStandardAddedRegisterResturant: {
        is_editable_quantity: true,
        is_editable_price: true
    },
    fakeSkuTalechStandardAdditionalRegisterRetail: {
        is_editable_quantity: true,
        is_editable_price: true
    },
    fakeSkuTalechPremiumAdditionalRegisterResturant : {
        is_editable_quantity: true,
        is_editable_price: true
    },
    fakeSkuTalechPremiumAddedRegisterRetail : {
        is_editable_quantity: true,
        is_editable_price: true
    },
};
const TALECH_ELO_BUNDLE = 'talechEloBundle';
const FEATURE_CODE_SINGLE = 'SINGLE';

//NOTE
//Algorithm
//3 states for this data
//First load: Here the offer block within the quote is empty.
//1. We select an offer and fetch the details. getEquipmentOffer()->getEntityOffer()
//2. We load and format the bundles and bundle_items to work with the UI (adding all the selected, is_visible etc flags). setEquipmentOffer()->setEntityOffer();
//3. Separate equipment_list from bundle_packages.
//4. We put all that data in the offering data block this.equipment_offer.
//5. UI displays data from the equipment_offer is now ready for user.

//Changing: If the user changes the offering_id
//1. We have to empty all the data in the equipment_offer block.
//2. fetch the new offer details
//3. do all the formatting and set the flags.
//4. Separate equipment_list from bundle_packages.
//5. put the new data in the equipment_offer.
//6. UI displays data from the equipment_offer is now ready for user.

//Updating: If the user is revisiting the page, i.e they've saved the offering data to their quote.
//1. We fetch the offer details for the current offer id.
//2. Format them and set the flags.
//3. Check with the quote offering data what the user has previously selected and set them.
//4. Separate equipment_list from bundle_packages.
//5. put the new data in the equipment_offer
//6. UI displays data from the equipment_offer is now ready for user.

//Note: on each data fetch and UI display, re run the validation function to add our rules to the UI.

//Saving
//1. Validate the existing data
//2. If validation fails, return error
//3. If validation doesn't fail, set the equipment_offer in the quote block and post it

export default {
    data () {
        return {
            equipment_currency: '',
            // equipment_offer: new EquipmentOffering(),
            // online_offer: new EquipmentOffering(),
            is_view: false,
            terminals_block: {
                is_open: true,
            },
            accessories_block: {
                is_open: false,
            },
            standalone_services_block: {
                is_open: true,
            },
            terminal_services_block: {
                is_open: false,
            },
            general_services_block: {
                is_open: true,
            },
            special_offer_block: {
                is_open: true,
            },
            third_party_equipment_block: {
                is_open: true,
            },
            talech_service_block: {
                is_open: true,
            },
            third_party_online_block: {
                is_open: true,
            },
            online_services_block: {
                is_open: true,
            },
            online_general_services_block: {
                is_open: false,
            },
            online_standalone_services_block: {
                is_open: true,
            },
            payment_method: {
                PAYMENT_METHOD_F2F_ONLY: "1",
                PAYMENT_METHOD_ECOM_ONLY: "2",
                PAYMENT_METHOD_BOTH: "3",
            },
            types: {
                TEXT: 'TEXT',
                LIST: 'LIST',
                NUMERIC: 'NUMERIC',
                BOOLEAN: 'BOOL',
            },
            equipment_types: {
                MOTO: 'MOTO',
                OTHER: 'OTHER',
                ECOM: 'ECOM',
                POS: 'POS',
                PERIPHERAL: 'PERIPHERAL',
            },
            billing_types: {
                FIXED: 'FIXED',
                DEFERRED: 'DEFERRED',
                ROLLING: 'ROLLING',
                PURCHASE: 'PURCHASE',
                NOT_APPLICABLE: 'N/A',
            },
            collect_on_boarding_types:{
                CONFIG: '0',
                BOARDING: '1',
                OFFER: '2',
            },
            packageList: [],
            acquiringOnlyParam: [{value: '1', label: this.lang('acquiring_only')}],
            additional_data_belong_to_list : {
                ADDITIONAL_DATA_BELONGS_TO_EQUIPMENT_OFFERING : '1',
                ADDITIONAL_DATA_BELONGS_TO_PROCESSING_OFFERING : '2',
                ADDITIONAL_DATA_BELONGS_TO_ONLINE_OFFERING : '3',
            },
            talech_service_logic: TALECH_SERVICE_LOGIC,
            custom_bundle_item_api_code_options: {
                talechEloBundle: ['fakeSKUPremiumInstallationService', 'fakeSKUCourierDeployment'],
            },
            entityOffer_abortController: null,
            FEATURE_CODE_SINGLE:FEATURE_CODE_SINGLE
        }
    },
    mounted () {
        //console.log('mounted');
        //this.packageList = this.setPackageList();
    },
    computed: {
        ...mapState(useApplicationStore, {
            matched_packages:'matched_packages',
            equipment_offerings:'equipment_offerings',
            online_offerings:'online_offerings',
            quote:'quote',
            parameters:'parameters',
            equipment_offer:'equipment_offer',
            online_offer:'online_offer',
            outlets:'outlets',
            criteria:'criteria'}),
        equipmentCurrencyCode: function (){
            let offer_currency = '', vm = this;
            if (!!vm.equipment_offer && !!vm.equipment_offer.equipment_offering_external_id) {
                offer_currency = vm.equipment_offer.currency;
            }
            else if (!!vm.online_offer && !!vm.online_offer.equipment_offering_external_id) {
                offer_currency = vm.online_offer.currency;
            }

            return offer_currency
        },
        currencySymbol: function () {
            let symbol = '', offer_currency = '', vm = this;

            if (vm.equipmentCurrencyCode !== '' && typeof vm.equipmentCurrencyCode !== 'undefined') {
                let currency = {};
                Object.keys(this.parameters.CURRENCIES_PARAM).forEach(function(key) {
                    if (key === vm.equipmentCurrencyCode) {
                        currency = vm.parameters.CURRENCIES_PARAM[key];
                    }
                });
                symbol = !!currency ? currency.currency_symbol : vm.equipmentCurrencyCode;
            }
            return symbol;
        },
        selectedPackageIsExpired: function (){
          return this.packageList.find(obj => { return obj.is_expired && obj.id === this.package_external_id})
        },
        numberSelectedEquipmentList: function (){
            let bundles = this.equipment_offer.equipment_list;
            let vm = this;
            return bundles.bundle_items.filter(item =>
                item.display && !!vm.bundleItemIsSelected(item)).length
        },
        numberSelectedBundlePackages: function  (){
            let bundles = this.equipment_offer.bundle_packages;
            let vm = this;
            return bundles.filter(bundle => bundle.is_boarding_activated === '1').length
            // return bundles.filter(bundle => (bundle.selected === '1' || !!bundle.selected) && bundle.selected !== '0').length
        },
        numberSelectedTerminals: function () {
            let bundles = this.equipment_offer.equipment_list;
            let vm = this;
            return bundles.bundle_items.filter(item =>
                vm.isEquipment(item) && item.display && vm.bundleItemIsSelected(item) && item.terminal_quantity > 0).length
        },
        numberSelectedServices: function () {
            let bundles = this.equipment_offer.equipment_list;
            let vm = this;
            return bundles.bundle_items.filter(item =>
                vm.isService(item) && item.display && vm.bundleItemIsSelected(item)).length
        },
        numberSelectedAccessories: function (){
            let bundles = this.equipment_offer.equipment_list;
            let vm = this;
            return bundles.bundle_items.filter(item =>
                vm.isAccessory(item) && item.display && vm.bundleItemIsSelected(item)).length
        },
        numberSelectedStandaloneServices: function (){
            let bundles = this.equipment_offer.equipment_list;
            let vm = this;
            return bundles.bundle_items.filter(item =>
                vm.isStandaloneService(item) && item.display && vm.bundleItemIsSelected(item)).length
        },
        numberSelectedGeneralServices: function (){
            let bundles = this.equipment_offer.equipment_list;
            let vm = this;
            return bundles.bundle_items.filter(item =>
                vm.isGeneralService(item) && item.display && vm.bundleItemIsSelected(item)).length
        },
        numberSelectedSpecialOffers: function (){
            let bundles = this.equipment_offer.equipment_list;
            let vm = this;
            return bundles.bundle_items.filter(item =>
                vm.isSpecialOfferService(item) && item.display && vm.bundleItemIsSelected(item)).length
        },
        numberSelectedThirdPartyEquipments: function (){
            let bundles = this.equipment_offer.equipment_list;
            let vm = this;
            return bundles.bundle_items.filter(item =>
                vm.isThirdPartyEquipmentService(item) && item.display && vm.bundleItemIsSelected(item)).length
        },
        numberSelectedTalechService: function (){
            let bundles = this.equipment_offer.equipment_list;
            let vm = this;
            return bundles.bundle_items.filter(item =>
                vm.isTalechService(item) && item.display && vm.bundleItemIsSelected(item)).length
        },
        numberSelectedThirdPartyOnline: function (){
            let bundles = this.online_offer.equipment_list;
            let vm = this;
            return bundles.bundle_items.filter(item =>
                vm.isThirdPartyEquipmentService(item) && item.display && vm.bundleItemIsSelected(item)).length
        },
        numberSelectedOnlineTerminalServices: function (){
            let bundles = this.online_offer.equipment_list;
            let vm = this;
            return bundles.bundle_items.filter(item =>
                vm.isService(item) && item.display && vm.bundleItemIsSelected(item)).length
        },
        numberSelectedOnlineGeneralServices: function (){
            let bundles = this.online_offer.equipment_list;
            let vm = this;
            return bundles.bundle_items.filter(item =>
                vm.isGeneralService(item) && item.display && vm.bundleItemIsSelected(item)).length
        },
        numberSelectedOnlineSpecialOfferServices: function (){
            let bundles = this.online_offer.equipment_list;
            let vm = this;
            return bundles.bundle_items.filter(item =>
                vm.isSpecialOfferService(item) && item.display && vm.bundleItemIsSelected(item)).length
        },
        numberSelectedOnlineStandaloneServices: function (){
            let bundles = this.online_offer.equipment_list;
            let vm = this;
            return bundles.bundle_items.filter(item =>
                vm.isStandaloneService(item) && item.display && vm.bundleItemIsSelected(item)).length
        },
        purchaseAgreementParam: function () {
            let length = [], purchase_length = [], vm = this;

            if (this.objectIsNotEmpty(this.equipment_offer.equipment_list)) {
                // We only care about the first bundle.
                let has_purchase_length = this.equipment_offer.equipment_list.bundle_items.some(
                    item => item.hasOwnProperty('billing_plans') &&  vm.objectIsNotEmpty(item.billing_plans) &&
                        item.billing_plans.some(plan => plan.billing_type === 'PURCHASE')
                )
                if (has_purchase_length){
                    purchase_length.push(
                        {
                            id: 'PURCHASE', text: this.lang('purchase'),
                            label: this.lang('purchase'),
                            value: 'PURCHASE'
                        },
                        // {
                        //     id: '',
                        //     text: this.lang('none'), label: this.lang('none'),
                        //     value: ''
                        // }
                        );
                }
            }

            if (this.npPropertyExistAndIsArray(this.equipment_offer, 'bundle_packages') &&
                this.equipment_offer.bundle_packages.length > 0 && purchase_length.length < 0) {
                let bundles_items = []
                this.equipment_offer.bundle_packages.forEach(obj => {
                    obj.bundle_items.forEach(item => {
                        bundles_items.push(item)
                    })
                })

                let has_purchase_length = bundles_items.filter(
                    item => item.hasOwnProperty('billing_plans') && item.billing_plans.length > 0 &&
                        item.billing_plans.some(plan => plan.billing_type === 'PURCHASE')
                )

                if (has_purchase_length){
                    purchase_length.push(
                        {
                            id: 'PURCHASE', text: this.lang('purchase'),
                            label: this.lang('purchase'),
                            value: 'PURCHASE'
                        });
                }
            }

            return purchase_length;
        },
        leaseAgreementParam: function () {
            let length = [], lease_length = [], vm = this, bundles_with_billing_plans = [];

            if (this.objectIsNotEmpty(this.equipment_offer.equipment_list)) {
                bundles_with_billing_plans = this.equipment_offer.equipment_list.bundle_items.filter(
                    item => item.hasOwnProperty('billing_plans') && item.billing_plans.length > 0
                )
            }

            if (this.npPropertyExistAndIsArray(this.equipment_offer, 'bundle_packages') && this.equipment_offer.bundle_packages.length > 0) {
                let bundles_items = []
                this.equipment_offer.bundle_packages.forEach(obj => {
                    obj.bundle_items.forEach(item => {
                        bundles_items.push(item)
                    })
                })

                let bundle_package_items_with_plans = bundles_items.filter(item => {
                   return item.hasOwnProperty('billing_plans') && item.billing_plans.length > 0
                })

                bundles_with_billing_plans = [...bundles_with_billing_plans, ...bundle_package_items_with_plans]
            }

            if (!!bundles_with_billing_plans) {
                bundles_with_billing_plans.forEach(bundle => {
                    bundle.billing_plans.forEach(plan => {
                        if (plan.hasOwnProperty('billing_length') && plan.billing_length !== ''
                            && length.indexOf(plan.billing_length) === -1) {
                            length.push(plan.billing_length)
                            let value = plan.billing_length;
                            let text = plan.billing_length + ' ' + vm.lang('months');
                            lease_length.push({
                                id: value, text: text,
                                label: text, value: value
                            });
                        }
                    })
                })
            }

            return this.sortLeaseLength(lease_length);
        },
        agreementLengthSelected: function () {
            return !!this.quote.agreement_length || this.quote.purchase_agreement_length === 'PURCHASE';
        },
        hasBundlePackage: function(){
          let vm = this;
          return this.objectIsNotEmpty(this.equipment_offer.bundle_packages)
        },
        hasTerminalEquipmentList: function (){
            return this.objectIsNotEmpty(this.equipment_offer.equipment_list)
        },
        hasOnlineEquipmentList: function (){
            return this.objectIsNotEmpty(this.online_offer.equipment_list)
        },
        hasEquipments: function (){
            let vm = this;
            return this.hasTerminalEquipmentList
                && this.equipment_offer.equipment_list.bundle_items.some(item => item.display && vm.isEquipment(item) && !vm.isAccessory(item))
        },
        hasAccessories: function () {
            let vm = this;
            return this.hasTerminalEquipmentList
                && this.equipment_offer.equipment_list.bundle_items.some(item => item.display && vm.isAccessory(item))
        },
        hasStandaloneServices: function (){
            let vm = this;
            return this.hasTerminalEquipmentList
                && this.equipment_offer.equipment_list.bundle_items.some(item => vm.isStandaloneService(item) && item.display)
        },
        hasSpecialOffers: function (){
            let vm = this;
            return this.hasTerminalEquipmentList
                && this.equipment_offer.equipment_list.bundle_items.some(item => vm.isSpecialOfferService(item) && item.display)
        },
        hasThirdPartyEquipments: function (){
            let vm = this;
            return this.hasTerminalEquipmentList
                && this.equipment_offer.equipment_list.bundle_items.some(item => vm.isThirdPartyEquipmentService(item) && item.display)
        },
        hasTalechServices: function (){
            let vm = this;
            return this.hasTerminalEquipmentList
                && this.equipment_offer.equipment_list.bundle_items.some(item => vm.isTalechService(item) && item.display)
        },
        hasGeneralServices: function (){
            let vm = this;
            return this.hasTerminalEquipmentList
                && this.equipment_offer.equipment_list.bundle_items.some(item => vm.isGeneralService(item) && item.display)
        },
        hasServices: function(){
            let vm = this;
            return this.hasTerminalEquipmentList
                && this.equipment_offer.equipment_list.bundle_items.some(item => vm.isService(item) && item.display)
        },
        hasOnlineServices: function (){
            let vm = this;
            return this.hasOnlineEquipmentList
                && this.online_offer.equipment_list.bundle_items.some(item => vm.isService(item) && item.display)
        },
        hasOnlineStandaloneServices: function (){
            let vm = this;
            return this.hasOnlineEquipmentList
                && this.online_offer.equipment_list.bundle_items.some(item => vm.isStandaloneService(item) && item.display)
        },
        hasOnlineSpecialOffers: function (){
            let vm = this;
            return this.hasOnlineEquipmentList
                && this.online_offer.equipment_list.bundle_items.some(item => vm.isSpecialOfferService(item) && item.display)
        },
        hasThirdPartyOnline: function (){
            let vm = this;
            return this.hasOnlineEquipmentList
                && this.online_offer.equipment_list.bundle_items.some(item => vm.isThirdPartyEquipmentService(item) && item.display)
        },
        hasOnlineGeneralServices: function (){
            let vm = this;
            return this.hasOnlineEquipmentList
                && this.online_offer.equipment_list.bundle_items.some(item => vm.isGeneralService(item) && item.display)
        },
        //selected computed
        hasSelectedBundlePackage: function (){
            let vm = this;
            let equipmentSelected = (bundles) => {
                return bundles.some(bundle => {
                    return bundle.bundle_items.some(bundle_item => {
                        return  vm.bundleItemIsSelected(bundle_item);
                    })
                })
            }
            return this.objectIsNotEmpty(this.equipment_offer.bundle_packages) && equipmentSelected(this.equipment_offer.bundle_packages)
        },
        hasSelectedTerminalEquipmentList: function () {
            return this.objectIsNotEmpty(this.equipment_offer.equipment_list) && this.equipment_offer.equipment_list.bundle_items.some(bundle_item => {
                return this.bundleItemIsSelected(bundle_item);
            })
        },
        hasSelectedTerminals: function (){
            let vm = this;
            return this.hasSelectedTerminalEquipmentList
                && this.equipment_offer.equipment_list.bundle_items.some(item => item.display && vm.isEquipment(item) && vm.bundleItemIsSelected(item))
        },
        hasSelectedOnlineEquipmentList: function (){
            let vm = this;
            return this.objectIsNotEmpty(this.online_offer.equipment_list)
                && this.online_offer.equipment_list.bundle_items.some(item => vm.objectIsNotEmpty(item.service) && item.display && vm.bundleItemIsSelected(item))
        },
        hasSelectedOnlineServices: function (){
            let vm = this;
            return this.hasSelectedOnlineEquipmentList
                && this.online_offer.equipment_list.bundle_items.some(item => vm.isService(item) && item.display && vm.bundleItemIsSelected(item))
        },
    },
    methods: {
        ...mapActions(useApplicationStore, [
            types.SET_EQUIPMENT_OFFER,
            types.SET_ACQUIRING_OFFER,
            types.SET_ONLINE_OFFER,
            types.EQUIPMENT_OFFERING,
            types.ACQUIRING_OFFERING,
            types.ONLINE_OFFERING,
        ]),
        setPackageList: function () {
            let vm = this,  package_list = [], payment_method = this.quote.payment_method;
            let packages = !!this.matched_packages ? Object.values(this.matched_packages) : [];
            if (packages.length > 0) {
                packages.forEach(obj => {
                    let packageObject = {
                        id: obj.criteria.package_external_id,
                        text: obj.criteria.package_name,
                        value: obj.criteria.package_external_id,
                        label: obj.criteria.package_name,
                        weight: obj.criteria.package_weight,
                        disabled: obj.criteria.package_status !== '1',
                    }
                    let is_valid_package = vm.isValidPackagePeriod(obj.criteria);

                    // If the package is already selected or the package is valid
                    if (vm.quote.package_external_id === obj.criteria.package_external_id || is_valid_package) {
                        packageObject.is_expired = is_valid_package === false;

                        if (vm.quote.girocard_only == '1' && !vm.packageHasGiroCardOnlyOffer(obj)) {
                            return; //skip the package
                        }

                        if (vm.quote.acquiring_only == '1' && !vm.packageHasAcquiringOnlyOffer(obj)) {
                            return;
                        }

                        if (!!vm.payment_method && (payment_method === vm.payment_method.PAYMENT_METHOD_F2F_ONLY) && vm.packageHasOffering(obj, 'online_offerings')) {
                            return;
                        }

                        if (!!vm.payment_method && (payment_method === vm.payment_method.PAYMENT_METHOD_ECOM_ONLY) && vm.packageHasOffering(obj, 'equipment_offerings')) {
                            return;
                        }
                        package_list.push(packageObject);
                    }
                })
                package_list.sort((a, b) => {
                    return parseFloat(b.weight) - parseFloat(a.weight);
                });
            }

            return package_list;
        },
        isValidPackagePeriod: function (package_data, throw_error = false) {
            if (package_data.is_offer_code_time_limited === '0') {
                return true;
            }

            let today = new Date();
            let offer_code_from = new Date(package_data['offer_code_from']);
            let offer_code_to = new Date(package_data['offer_code_to']);
            if (today < offer_code_from || today > offer_code_to) {
                if (throw_error) {
                    //'Offer Package %0% is expired or currently unavailable. Please select a new Offer Package.
                    this.notifyError(this.lang('validation_error'), this.lang('validation_offer_package_is_expired').replace('{0}', package_data.package_name))
                }
                return false;
            }
            return true;
        },
        validateOfferPackagePeriod: function (){
            let package_external_id = !!this.package_external_id ? this.package_external_id : '';
            let selected_package = this.matched_packages.hasOwnProperty(package_external_id) ? this.matched_packages[package_external_id] : null;

            if(!!selected_package){
                if (!this.isValidPackagePeriod(selected_package.criteria, true)){
                    return false;
                }
            }else{
                this.notifyError(this.lang('validation_error'), this.lang('your_offer_package_is_invalid'))
                return false;
            }

            return true;
        },
        packageHasGiroCardOnlyOffer: function (package_obj) {
            return !!package_obj.criteria && package_obj.criteria.girocard_only == '1'
        },
        packageHasAcquiringOnlyOffer: function (package_list) {
            let has_acquiring_offer = false, acquiring_offer = null;
            if (this.packageHasOffering(package_list, 'equipment_offerings')) {
                acquiring_offer = package_list.equipment_offerings.filter(offer => {
                    return offer.acquiring_only == '1'
                })

                has_acquiring_offer = acquiring_offer.length > 0;
            }

            //don't bother if there is already an acquiring offer in equipment
            if (!has_acquiring_offer && this.packageHasOffering(package_list, 'online_offerings')) {
                acquiring_offer = package_list.online_offerings.filter(offer => {
                    return offer.acquiring_only == '1'
                })

                has_acquiring_offer = acquiring_offer.length > 0;
            }

            return has_acquiring_offer;
        },
        isOnlineOnlyOfferPackage: function (){
            let package_external_id = !!this.package_external_id ? this.package_external_id : '';
            let selected_package = this.matched_packages.hasOwnProperty(package_external_id) ? this.matched_packages[package_external_id] : null;

            return !!selected_package && this.objectIsNotEmpty(selected_package.online_offerings) && !this.objectIsNotEmpty(selected_package.equipment_offerings);
        },
        toggleAccordionSection: function  (block){
            block.is_open = !block.is_open
        },
        packageHasOffering: function (package_list, offering_name) {
            return package_list && package_list.hasOwnProperty(offering_name) && package_list[offering_name].length > 0
        },
        addValidationRules: function (){
            setTimeout(function () {
                $("#form").formValidator({
                    // triggerElement: '', //trigger element default $('form').find('button[type="submit"]')
                    triggerEvent: '', // event - default 'click'
                    defaultConfig: '', // {} - object to set different configuration in validate.js
                    scrollToError: '', // enable auto-scroll to invalid element default true expect boolean
                    additionalCallbackFunction: '',
                });
            }, 1000);
        },
        setBundleItemValues: function (bundle_item){
            if(!bundle_item.terminal_quantity > 0 ){
                bundle_item.terminal_quantity = 1
            }
        },
        bundleItemIsSelected: function (bundle_item){
            return bundle_item.is_boarding_activated === '1';
            // return (bundle_item.selected == '1' || !!bundle_item.selected) && bundle_item.selected !== '' && bundle_item.selected != '0';
        },
        toggleEquipmentSelection: function (bundle_item, val) {
            bundle_item.selected = (val != 0);
            bundle_item.is_boarding_activated = val != 0 ? '1' : '0';
        },

        isRequired: function (bundle_item) {
            return !!bundle_item.selected && bundle_item.selected;
        },
        isMultiTerminal: function (bundle,bundle_item) {
            return !!bundle && bundle.bundle_name === 'SYSTEM_GENERATED' && bundle_item.equipment.allow_multiple_on_sb === '1';
        },
        sortLeaseLength: function (leaseLengths) {
            if (leaseLengths.length > 0) {
                function compare(a, b) {
                    if (parseInt(a.value) > parseInt(b.value)) {
                        return 1;
                    }
                    if (parseInt(a.value) < parseInt(b.value)) {
                        return -1;
                    }
                    // a must be equal to b
                    return 0;
                }

                return this.jsonCopy(leaseLengths).sort(compare);
            }
            return [];
        },
        equipmentIsDisabled: function (bundle_item) {
            // let is_disabled= true;
            //TODO check if is equipment of services

           return (this.isEquipment(bundle_item) || this.isAccessory(bundle_item)) && this.agreementLengthSelected ?
                this.equipmentIsMandatory(bundle_item) : this.equipmentIsMandatory(bundle_item);

            // if (!this.isEquipment(bundle_item) && !this.isAccessory(bundle_item)){
            //     is_disabled = this.equipmentIsMandatory(bundle_item)
            // }else{
            //     if(!!this.agreementLengthSelected){
            //         is_disabled = this.equipmentIsMandatory(bundle_item)
            //     }
            // }

            // return is_disabled
        },
        getSelectedEquipmentOffer: function (offer){

            let agreement_length_exist = (!!this.quote.agreement_length) && (this.quote.agreement_length !== '');
            let agreement_length = agreement_length_exist ? this.quote.agreement_length : this.quote.purchase_agreement_length;

            let selected_offer = {
                bundles: [],
                agreement_length: agreement_length,
                equipment_offering_external_id: offer.equipment_offering_external_id
            };
            if (offer.acquiring_only === '1') {
                selected_offer.acquiring_only = '1';
            }

            //additional_data
            if (this.npPropertyExistAndIsArray(offer, 'additional_data')){
                selected_offer.additional_data = offer.additional_data;
            }

            let offerData = this.jsonCopy(offer)
            offerData.bundles = [];
            //merge equipment_list and bundle_packages into the bundles[]
            offerData.bundles.push(offer.equipment_list)

            if (offer.hasOwnProperty('bundle_packages') && offer.bundle_packages.length > 0){
            offer.bundle_packages.forEach(obj => offerData.bundles.push(obj));
            }

            offerData.bundles.forEach((bundle, bundle_index) => {
                if (bundle.individual_item_only === '0' && bundle.is_boarding_activated === '0') {  //predefined bundle

                } else if (bundle.individual_item_only === '0' && bundle.is_boarding_activated === '1') { //predefined bundle
                    this.setAutoSelectedFeatures(bundle.bundle_items);

                    //selected  bundle_packages
                    selected_offer.bundles.push({
                        equipment_bundle_external_id: bundle.equipment_bundle_external_id,
                        bundle_name: bundle.bundle_name,
                        bundle_items: bundle.bundle_items,
                        selected: bundle.selected,
                        is_boarding_activated: bundle.is_boarding_activated,
                        individual_item_only: bundle.individual_item_only,
                    })
                } else if(bundle.individual_item_only === '1') { //system generated bundle
                    //equipment_list
                    if (bundle.bundle_items.length > 0) {

                        this.setAutoSelectedFeatures(bundle.bundle_items);

                        let selected_bundle_items = [];
                        bundle.bundle_items.forEach((bundle_item, bundle_item_index) => {
                            if (bundle_item.is_boarding_activated === '1') {
                                selected_bundle_items.push(bundle_item)
                            }
                        })

                        if (selected_bundle_items.length > 0) {
                            selected_offer.bundles.push({
                                equipment_bundle_external_id: bundle.equipment_bundle_external_id,
                                bundle_name: bundle.bundle_name,
                                bundle_items: selected_bundle_items,
                                selected: '1',
                                is_boarding_activated: '1',
                                individual_item_only: bundle.individual_item_only,
                            })
                        }
                    }
                }
            })

            return selected_offer;

        },
        setAutoSelectedFeatures: function (bundle_items) {
            /* some features are auto selected */
            // console.log('setAutoSelectedFeatures');
            let vm = this;
            if (!!bundle_items && Array.isArray(bundle_items)) {
                bundle_items.forEach(bundle_item => {
                    if (bundle_item.is_boarding_activated === '1' && !!(bundle_item.equipment_features) && Array.isArray(bundle_item.equipment_features)) {
                        bundle_item.equipment_features.forEach(feature => {
                            if (!!feature.collect_on_boarding && feature.collect_on_boarding === vm.collect_on_boarding_types.OFFER) {
                                feature.selected = '1';
                                feature.value = feature.collect_on_value;
                            }
                        })
                    }

                    //set service features only for services that aren't standalone (i.e pci or billing statement)
                    if (bundle_item.is_boarding_activated === '1' && !vm.isStandaloneService(bundle_item) && !!(bundle_item.service_features) && Array.isArray(bundle_item.service_features)) {
                        bundle_item.service_features.forEach(feature => {
                            if (!!feature.collect_on_boarding && (feature.collect_on_boarding === vm.collect_on_boarding_types.OFFER || feature.collect_on_boarding === vm.collect_on_boarding_types.CONFIG)) {
                                feature.selected = '1';
                                feature.value = feature.collect_on_value;
                            }
                        })
                    }
                })
            }
        },
        checkOnlineOfferIsSelected: function (offerObject){
            let selected_services = 0, vm = this;
            let is_acquiring_only = offerObject.hasOwnProperty('acquiring_only') && offerObject.acquiring_only === '1'
            if (offerObject.hasOwnProperty('equipment_list') && this.npPropertyExistAndIsArray(offerObject.equipment_list, 'bundle_items')) {
                selected_services = offerObject.equipment_list.bundle_items.filter(item => {
                    if (is_acquiring_only) {
                        return vm.bundleItemIsSelected(item);
                    } else {
                        return vm.isService(item) && item.terminal_quantity > 0 && vm.bundleItemIsSelected(item) && item.is_invisible != '1'

                    }
                }).length;
            }

            return parseInt(selected_services) > 0;
        },
        checkEquipmentOfferIsSelected: function (offerObject) {
            let vm = this, selected_equipments = 0;
            let has_acquiring_only = offerObject.hasOwnProperty('acquiring_only') && offerObject.acquiring_only === '1'
            if (offerObject.hasOwnProperty('equipment_list') && this.objectIsNotEmpty(offerObject.equipment_list)) {
                if (has_acquiring_only) {
                    selected_equipments = offerObject.equipment_list.bundle_items.filter(item => {
                        return item.terminal_quantity > 0 && vm.bundleItemIsSelected(item)
                    }).length
                } else {
                    selected_equipments = offerObject.equipment_list.bundle_items.filter(item => {
                        return this.isEquipment(item) && item.terminal_quantity > 0 && vm.bundleItemIsSelected(item)
                    }).length
                }
            }

            let selected_bundle_packages = 0;
            if (offerObject.hasOwnProperty('bundle_packages') && this.objectIsNotEmpty(offerObject.bundle_packages)){
                selected_bundle_packages =   offerObject.bundle_packages.filter(bundle => {
                    return bundle.is_boarding_activated === '1'
                }).length
            }

            if (has_acquiring_only){
                return selected_equipments > 0
            }else {
                return (parseInt(selected_equipments) + parseInt(selected_bundle_packages)) !== 0;
            }

            //For selecting multiple equipments DO NOT DELETE
            //check that alteast one bundle item from either equipment_list or  bundle_packages is selected
            //online_offering doesn't have bundle_packages
            // let is_valid = !!(offerObject.equipment_list.bundle_items.some(item => {
            //     return item.selected || item.terminal_quantity > 0 || item.selected === '1'
            // }) || ((offerObject.hasOwnProperty('bundle_packages') &&
            //     offerObject.bundle_packages.some(bundle => {
            //         return bundle.bundle_items.some(item => {
            //             return item.selected || item.terminal_quantity > 0 || item.selected === '1'
            //         })
            //     }))));
            // return is_valid;
        },
        isBundleItemActivated: function (item){
            let vm = this;
            return !!item.is_boarding_activated && item.is_boarding_activated === '1';
        },
        equipmentIsSelected: function (bundle_item) {
            let is_selected = false;
            if (!!this.agreementLengthSelected) {
                is_selected = this.equipmentIsMandatory(bundle_item) || bundle_item.terminal_quantity > 0 ? '1' : '0'
            }else if (!this.isEquipment(bundle_item) && !this.isAccessory(bundle_item)){ //target online services that have no agreement length
                is_selected = this.equipmentIsMandatory(bundle_item) || this.bundleItemIsSelected(bundle_item) ? '1' : '0';
            }

            // if (is_selected){
            // this.toggleSelectedTerminals(bundle_item)
            // }

            return is_selected;
        },
        toggleSelectedTerminals: function (bundle_item){
                if (this.quote.payment_method === '1'){
                    this.equipment_offer.equipment_list.bundle_items.forEach(obj => {
                        obj.selected = obj.is_mandatory === '1';
                        obj.terminal_quantity = 0;

                        if (obj.equipment_bundle_item_external_id === bundle_item.equipment_bundle_item_external_id){
                            obj.selected = true;
                            obj.terminal_quantity = 1;
                        }
                    })

                    if (this.equipment_offer.hasOwnProperty('bundle_packages') && this.objectIsNotEmpty(this.equipment_offer.bundle_packages)){
                        this.equipment_offer.equipment_list.bundle_items.forEach(obj => {
                            obj.selected = false;
                            obj.terminal_quantity = 0;

                            if (obj.equipment_bundle_item_external_id === bundle_item.equipment_bundle_item_external_id){
                                obj.selected = true;
                                obj.terminal_quantity = 1;
                            }
                        })
                    }
                }
        },
        onlineIsDisabled: function (bundle_item) {
            return this.equipmentIsMandatory(bundle_item)
        },
        onlineIsSelected: function (bundle_item, equipment) {
            return this.equipmentIsMandatory(bundle_item) || bundle_item.terminal_quantity > 0 ? '1' : '0';
        },
        offerHasTalechServices: function (boarding_offer) {
            let vm = this;
            let service_exist = false;
            if (vm.npPropertyExistAndIsArray(boarding_offer, 'bundles')) {
                return boarding_offer.bundles.some(bundle => {
                    return (vm.npPropertyExistAndIsArray(bundle, 'bundle_items'))
                        && bundle.bundle_items.some(bundle_item => vm.isTalechService(bundle_item));
                });
            }
            return service_exist;
        },
        canGeneralServiceDisplay: function (bundle, bundle_item) {
            if (this.isGeneralService(bundle_item)) {
                //if the GS linked options based on  to any equipment
                const bundle_item_option = Object.entries(this.custom_bundle_item_api_code_options).find(
                    ([api_key, value]) => value.includes(bundle_item.service.service_api_code));
                //collect the object: if the service is part of any custom_bundle_item_api_code_options
                if (!!bundle_item_option) {
                    const [equipment_api_code, linked_api_codes] = bundle_item_option;
                    //for current logic : talechEloBundle
                    if (linked_api_codes.includes(bundle_item.service.service_api_code)) {
                        const master_equipment = bundle.bundle_items.find(bundle_item => bundle_item.equipment.equipment_api_code === equipment_api_code && bundle_item.is_boarding_activated === '1')
                        return !!master_equipment
                    }
                }
                return true
            }
        },
        isSystemGeneratedEquipmentBundle: function (bundle) {
            return bundle.hasOwnProperty('bundle_name') && bundle.bundle_name === 'SYSTEM_GENERATED';
        },
        updateFeaturesAndCharges: function (bundle_item, $event) {
            if (bundle_item.hasOwnProperty('service_features') && bundle_item.service_features.length > 0) {
                bundle_item.service_features.forEach(feature => {
                    feature.disabled = $event !== '1' //enable all features is bundle is selected
                    if (!feature.is_selectable) { //set the non-selectable features to selected
                        feature.selected = $event
                    }
                    if (feature.is_required === '1'){
                        feature.selected = $event !== '1' ? $event : '1';
                        feature.disabled = '1';
                    }

                    if(feature.selected === '1'){
                        this.selectFeatureItem(feature, feature.is_required === '1')
                    }
                })
            }

            if (bundle_item.hasOwnProperty('service_charges') && bundle_item.service_charges.length > 0) {
                bundle_item.service_charges.forEach(charge => {
                    charge.is_selected = $event
                    charge.selected = $event
                })
            }
            return bundle_item
        },
        selectFeatureItem: function (item, is_required = false) {
            //set value on select
            item['value'] = !!item['value'] ? item['value'] : item.hasOwnProperty('collect_on_value') ?
                item['collect_on_value'] : item['default_value'];

            //set the disabled field based on collect_on_boarding
            if (item['collect_on_boarding'] === this.collect_on_boarding_types.OFFER) {
                item['disabled'] = true
            } else if (item['collect_on_boarding'] === this.collect_on_boarding_types.CONFIG) {
                item['disabled'] = true;
            } else {
                item['disabled'] = false;
            }
            if (!!is_required) {
                item['is_required'] = '1';
            }
            return item
        },
        resetCustomEquipmentServicesBundleItem: function (bundle, bundle_item, equipment_api_code = null) {
            if (bundle && this.isSystemGeneratedEquipmentBundle(bundle)) {
                const bundle_item_option = Object.entries(this.custom_bundle_item_api_code_options).find(
                    ([api_key, value]) => value.includes(bundle_item.service.service_api_code));
                if (!!bundle_item_option && this.npPropertyExistAndIsArray(bundle, 'bundle_items')) {
                    bundle.bundle_items.forEach(item => {
                        const item_service_api_code = item.service.service_api_code || '';
                        const code_options = this.custom_bundle_item_api_code_options[equipment_api_code] || null;
                        if (!!code_options && code_options.includes(item_service_api_code)
                            && equipment_api_code === TALECH_ELO_BUNDLE) {

                            if (!!bundle_item && item.equipment_bundle_item_external_id !==
                                bundle_item.equipment_bundle_item_external_id) {
                                this.updateFeaturesAndCharges(item, '0');
                                item['is_boarding_activated'] = '0';
                            }
                        }
                    });
                }
            }
        },
        cleanCustomEquipments: function (bundle, bundle_item) {
            let vm = this;
            for (const [equipment_api_code, linked_api_codes] of Object.entries(vm.custom_bundle_item_api_code_options)) {
                const master_equipment = bundle_item.equipment.equipment_api_code === equipment_api_code && bundle_item.is_boarding_activated === '1'
                if (equipment_api_code === TALECH_ELO_BUNDLE && !master_equipment) {
                    bundle.bundle_items.forEach(bundle_item => {
                        const item_service_api_code = bundle_item?.service?.service_api_code || '';
                        if (!!linked_api_codes && linked_api_codes.includes(item_service_api_code)) {
                            vm.updateFeaturesAndCharges(bundle_item, '0')
                            bundle_item['is_boarding_activated'] = '0';
                        }
                    })
                }
            }
        },
        isFeatureCodeConfiguredInBundleItem:function (bundle_item, feature_api_code) {
            //check any api_code logic checks

            return this.isEquipmentFeatureCodeConfiguredInBundleItem(bundle_item, feature_api_code)
                || this.isServiceFeatureCodeConfiguredInBundleItem(bundle_item, feature_api_code);
        },
        isEquipmentFeatureCodeConfiguredInBundleItem:function (bundle_item, feature_api_code) {
            //check any api_code logic checks
            if (bundle_item.hasOwnProperty('equipment_features') && bundle_item.equipment_features.length > 0) {
                const {equipment_features} = bundle_item
                return (equipment_features.find(f => f.feature_api_code === feature_api_code));
            }

            return false;
        },
        isServiceFeatureCodeConfiguredInBundleItem:function (bundle_item, feature_api_code) {
            //check any api_code logic checks
            if (bundle_item.hasOwnProperty('service_features') && bundle_item.service_features.length > 0) {
                const {service_features} = bundle_item
                return (service_features.find(f => f.feature_api_code === feature_api_code));
            }

            return false;
        },
        setBundleItemByCustomFeatureLogic:function (bundle_item) {
            const has_single_feature = this.isEquipmentFeatureCodeConfiguredInBundleItem(bundle_item, FEATURE_CODE_SINGLE);
            if (has_single_feature) {
                bundle_item.terminal_quantity = '1'
            }
        },


        equipmentIsMandatory: function (bundle_item) {
            return bundle_item.is_mandatory === '1';
        },
        isEquipment: function (bundle_item) {
            return !!this.objectIsNotEmpty(bundle_item.equipment) && !this.objectIsNotEmpty(bundle_item.service) && bundle_item.equipment.equipment_pos_type !== ACCESSORY
        },
        isService: function (bundle_item) {
            return !!this.objectIsNotEmpty(bundle_item.service) && !this.isStandaloneService(bundle_item) && !this.isGeneralService(bundle_item)
                && !this.isSpecialOfferService(bundle_item) && !this.isThirdPartyEquipmentService(bundle_item) && !this.isTalechService(bundle_item);
        },
        isStandaloneService: function (bundle_item) {
            return !!this.objectIsNotEmpty(bundle_item.service) && bundle_item.service.service_type === STANDALONE_SERVICE
        },
        isGeneralService: function (bundle_item) {
            let general_services = [GLOBAL_FEATURE, FASTER_PAYMENT, AMEX_SERVICE, CENTRAL_CLEARING];
            return !!this.objectIsNotEmpty(bundle_item?.service) && general_services.includes(bundle_item.service.service_type)
        },
        isElavonGateway: function (bundle_item) {
            return !!this.objectIsNotEmpty(bundle_item.service) && (bundle_item.service.service_type === ELAVON_GATEWAY);
        },
        isSpecialOfferService: function (bundle_item) {
            return !!this.objectIsNotEmpty(bundle_item.service) && (bundle_item.service.service_type === SPECIAL_OFFER)
        },
        isThirdPartyEquipmentService: function (bundle_item) {
            return !!this.objectIsNotEmpty(bundle_item?.service) && (bundle_item.service?.service_type === THIRD_PARTY_EQUIPMENT)
        },
        isTalechService: function (bundle_item) {
            return !!this.objectIsNotEmpty(bundle_item?.service) && (bundle_item.service?.service_type === TALECH_SERVICE)
        },
        isOnlineService: function (item){
            let vm = this;
            return vm.isService(item) || vm.isStandaloneService(item) || vm.isGeneralService(item);
        },
        isAccessory: function (bundle_item){
            return !!this.objectIsNotEmpty(bundle_item.equipment) && bundle_item.equipment.equipment_pos_type === ACCESSORY
        },
        getCost: function (bundle_item) {
            return !!this.agreementLengthSelected ?
                 this.formatNumberByLocale(bundle_item.terminal_unit_price, 2, 'currency', this.equipmentCurrencyCode) : this.formatNumberByLocale(0.00);
        },
        getTotal: function (bundle_item) {
            return !!this.agreementLengthSelected &&  !!bundle_item.terminal_quantity ?
                this.currencySymbol + this.formatNumberByLocale(bundle_item.terminal_quantity * bundle_item.terminal_unit_price) : this.currencySymbol + this.formatNumberByLocale(0.00);
        },
        getServiceTotal: function (bundle_item) {
            let setup_fee = bundle_item.service_charges.find(obj => obj.service_frequency === '1');
            if (!!setup_fee) {
                return this.getServiceCharge(setup_fee);
            }
            return '-';
        },
        getServiceCharge: function (service_charge, view_only=false){
            let vm  = this, charge = '';
            if (service_charge.hasOwnProperty('fee_or_billing') && service_charge.fee_or_billing !== SERVICE_CHARGE_ITEM_BILLING) {
                switch (service_charge.fee_type) {
                    case '1': //Perc
                            charge = vm.formatNumberByLocale(service_charge.service_perc_charge) + '%';
                        break;

                    case '2': //Base
                            charge = vm.formatNumberByLocale(service_charge.service_base_charge, service_charge.charge_decimals, 'currency', vm.equipmentCurrencyCode);
                        break;

                    case '3':
                        charge = vm.formatNumberByLocale(service_charge.service_base_charge, service_charge.charge_decimals, 'currency', vm.equipmentCurrencyCode);
                            + '/' + vm.formatNumberByLocale(service_charge.service_perc_charge) + '%';
                        break;

                    default:
                            charge = vm.formatNumberByLocale(service_charge.service_base_charge, service_charge.charge_decimals, 'currency', vm.equipmentCurrencyCode);
                        break;
                }
            }
            else {
                    charge = vm.formatNumberByLocale(service_charge.service_base_charge, service_charge.charge_decimals, 'currency', vm.equipmentCurrencyCode);
            }

            let frequency = (service_charge.service_frequency && service_charge.service_frequency !== '1') ? vm.formatServiceFrequency(service_charge.service_frequency) : '';
            return charge + ' ' + frequency;
        },
        getServiceChargePrice: function (default_value, charge_decimals) {
            return this.formatNumberByLocale(default_value, parseInt(charge_decimals), 'currency', this.equipmentCurrencyCode)
        },
        formatServiceFrequency : function (data){
            return this.formatSelectType(this.parameters, data, 'SERVICE_FREQUENCY');
        },
        formatEquipmentOffering: function (data){
                let offer = this.equipment_offerings.find(obj => {
                    return obj.equipment_offering_external_id === data
                })
            return !!offer ? offer.offering_name : '-';
        },
        formatPackage: function (data){
                let offer = this.packageList.find(obj => {
                    return obj.id === data
                })
            return !!offer ? offer.text : '-';
        },
        formatOnlineOffering: function (data){
                let offer = this.online_offerings.find(obj => {
                    return obj.equipment_offering_external_id === data
                })
            return !!offer ? offer.offering_name : '-';
        },
        getBundleItemEquipmentFirstImage: function (bundle_item) {
            let vm = this;
            // return `${vm.defaultImageLink}`;

            if (bundle_item.hasOwnProperty('equipment') && bundle_item.hasOwnProperty('equipment_images')
                && Array.isArray(bundle_item.equipment_images)) {
                return vm.imageSource() + bundle_item.equipment_images[0].image_name;
            }
            else {
                return vm.defaultImageLink();
            }
        },
        getBundleItemServiceFirstImage: function (bundle_item) {
            let vm = this;
            // return `${vm.defaultImageLink}`;

            if (bundle_item.hasOwnProperty('service') && bundle_item.hasOwnProperty('service_images')
                && Array.isArray(bundle_item.service_images)) {
                return vm.imageSource() + bundle_item.service_images[0].image_name;
            }
            else {
                return vm.defaultImageLink();
            }
        },
        getBundleItemFeatures: function (bundle_item) {
            if (this.isEquipment(bundle_item)) {
                return bundle_item.hasOwnProperty('equipment_features') && bundle_item.equipment_features.length > 0 ?
                bundle_item.equipment_features.filter(feature => feature.is_visible === true) : [];
            }
            else if (this.isService(bundle_item) || this.isStandaloneService(bundle_item) || this.isGeneralService(bundle_item)
            || this.isSpecialOfferService(bundle_item) || this.isThirdPartyEquipmentService(bundle_item)) {
                return bundle_item.service_features;
            }
            else {
                return [];
            }
        },
        featureIsSelected: function(feature){
            //set priceable service
            if (!!feature.selected === '1' && feature.is_priceable ==='1'){
                //TODO select the connected services
            }
            this.setFeatureToDefaultValue(feature)
        },
        onUnitNormalise: function (item, key, charge_decimals) {
            // console.log('onUnitNormalise', item, key, charge_decimals);
            if (item.hasOwnProperty(key)) {
                if (!isNaN(item[key]) && Number(item[key]) !== 0 && item[key] !== '') {
                    item[key] = Number(item[key].toFixed(charge_decimals));
                }
            }
        },
        setFeatureToDefaultValue: function (feature) {
            if (feature.selected === '1') {
                if(feature.feature_input_type !== this.types.LIST && !!feature.default_value) {
                    feature.value = feature.default_value;
                } else  {
                    if(!!feature.default_value) {
                        feature.value = Object.values(feature.default_value).toString();
                    }
                }
            } else {
                feature.value = '';
            }
        },
        getFeatureList: function (feature) {
            let feature_list = [];
            if (feature.hasOwnProperty('list_of_values') && Object.entries(feature.list_of_values).length > 0) {
                if (feature.collect_on_boarding === this.collect_on_boarding_types.BOARDING && feature.hasOwnProperty('default_values')) {
                    let default_values = feature.alliance_default_value.split(",");
                    if (default_values.length > 0) {
                        for (const feature_external_id of default_values) {
                            if (feature.list_of_values.hasOwnProperty(feature_external_id)) {
                                let value = feature.list_of_values[feature_external_id]
                                feature_list.push({id: feature_external_id, text: value})
                            }
                        }
                    }
                } else {
                    for (const [feature_external_id, value] of Object.entries(feature.list_of_values)) {
                        feature_list.push({id: feature_external_id, text: value})
                    }
                }
            }
            return feature_list;
        },
        getServiceFeatureList: function (feature) {
            let feature_list = [];
            if (feature.hasOwnProperty('list_of_values') &&  Object.entries(feature.list_of_values).length > 0) {
                for (const [key, value] of Object.entries(feature.list_of_values)) {
                    feature_list.push({id: key, text: value})
                }
            }
            return feature_list;
        },
        itemHasServiceCharges: function (bundle_item, is_view = false){
            let has_charges = bundle_item.hasOwnProperty('service_charges') && bundle_item.service_charges.length > 0;

            if (is_view){
                has_charges = bundle_item.service_charges.some(obj => obj.selected === '1')
            }
            return has_charges;
        },
        itemHasFeatures: function (bundle_item){
            let features = this.getBundleItemFeatures(bundle_item);
            return this.objectIsNotEmpty(features)
            // return this.objectIsNotEmpty(features) && features.some(feature => feature.is_visible === true)
        },
        defaultImageLink: function () {
            // return 'https://devmtconfig.technologi.co.uk/assets/default/img/terminal_icon.png';

            return `${window.location.origin + '/assets/default/img/terminal_icon.png'}`
        },
        imageSource: function () {
            return `${window.location.origin}/application/viewimage?img=/`;
        },
        filterByAgreementLength: function (){
            let vm = this, selected_length = [];
            if (this.quote.purchase_agreement_length === 'PURCHASE'){
                selected_length.push(this.quote.purchase_agreement_length)
            }
            if (!!this.quote.agreement_length){
                selected_length.push(this.quote.agreement_length.split('_')[0]);
            }


            // in the instance when there is no selected length, check which agreement type (lease or purchase) param is active
            //set the respective parameter with the first value in the param as the respective agreement length
            if (selected_length.length === 0) {
                if (this.leaseAgreementParam.length > 0) {
                    let lease_length = this.leaseAgreementParam[0].id;

                    if (!!lease_length) {
                        this.quote.agreement_length = lease_length
                        selected_length.push(this.quote.agreement_length.split('_')[0]);
                    }
                }

                if (this.purchaseAgreementParam.length > 0) {
                    let purchase_length = this.purchaseAgreementParam[0].id;

                    if (purchase_length === 'PURCHASE') {
                        this.quote.purchase_agreement_length = purchase_length;
                        selected_length.push(this.quote.purchase_agreement_length)
                    }
                }
            }

            //dont filter in view mode
            if (selected_length.length > 0 && !this.is_view && !!this.equipment_offer && !!this.equipment_offer.equipment_list) {
                this.equipment_offer.equipment_list.bundle_items.forEach(bundle_item => {
                    //display if it matches the agreement length and bundle item is not invisible.
                    if (bundle_item.hasOwnProperty('billing_plans') && this.objectIsNotEmpty(bundle_item.billing_plans)) {
                        bundle_item.display = false;

                        let matched_plan = bundle_item.billing_plans.find(billing_plan => {
                            return (!!billing_plan.billing_length && selected_length.indexOf(billing_plan.billing_length) > -1) ||
                                (!billing_plan.billing_length && selected_length.indexOf('PURCHASE') > -1);
                        })
                        if (!!matched_plan) {
                            bundle_item.display = !!matched_plan && bundle_item.is_invisible == '0';
                            bundle_item.selected = bundle_item.is_mandatory === '1'? true : bundle_item.selected;
                            bundle_item.is_boarding_activated = bundle_item.is_mandatory === '1'? '1' : bundle_item.is_boarding_activated;
                            bundle_item.terminal_quantity = vm.bundleItemIsSelected(bundle_item) ? bundle_item.terminal_quantity : 0;
                            bundle_item.terminal_unit_price = matched_plan.default_charge;
                            bundle_item.agreement_length = !!matched_plan.billing_length ? matched_plan.billing_length : 'PURCHASE';
                            // bundle_item.billing_method_external_id = matched_plan.billing_method_external_id;
                        } else {
                            //if item doesn't match, un select the equipment  and it's features
                            bundle_item.terminal_quantity = 0;
                            bundle_item.selected = '';
                            bundle_item.is_boarding_activated = '';
                        }
                    }
                })

                this.equipment_offer.bundle_packages.forEach(bundle_package => {
                    //bundle package should be hidden unless one of the bundle_item billing plan matches the agreement_length
                    bundle_package.display = bundle_package.is_boarding_activated === '1';

                    bundle_package.bundle_items.forEach(bundle_item => {
                        //display if it matches the agreement length and bundle item is not invisible.
                        if (bundle_item.hasOwnProperty('billing_plans') && this.objectIsNotEmpty(bundle_item.billing_plans)) {
                            bundle_item.display = true;

                            let matched_plan = bundle_item.billing_plans.find(billing_plan => {
                                return (!!billing_plan.billing_length && selected_length.indexOf(billing_plan.billing_length) > -1) ||
                                    (!billing_plan.billing_length && selected_length.indexOf('PURCHASE') > -1);
                            })
                            if (!!matched_plan) { //bundle must be selected
                                bundle_package.display = true;
                                bundle_item.selected = !!bundle_package.selected;
                                bundle_item.is_boarding_activated = bundle_package.is_boarding_activated;
                                // bundle_item.display = !!matched_plan && bundle_item.is_invisible == '0';
                                bundle_item.terminal_unit_price = matched_plan.default_charge;
                                bundle_item.terminal_quantity = bundle_item.terminal_quantity;
                                bundle_item.agreement_length = !!matched_plan.billing_length ? matched_plan.billing_length : 'PURCHASE';
                            }
                        // else {
                        //         //if item doesn't match, un select the equipment  and it's features
                        //         bundle_item.terminal_quantity = 0;
                        //         bundle_item.selected = '';
                        //     }
                        }
                    })
                })
            }
        },
        ///made these functions because the watch was causing multi requests.
        getEquipmentOffer: function (id){
            //made it a  state property because I can't retrieve it on validation in business/index.vue
            this[types.SET_EQUIPMENT_OFFER](new EquipmentOffering({equipment_offering_external_id: id}))

            // this.$set(this, 'equipment_offer', new EquipmentOffering({equipment_offering_external_id: id}));

            // this.$set(this.quote, 'equipment_offer', {});
            this.getEntityOffer(id);
        },
        getOnlineOffer: function (id){
            this[types.SET_ONLINE_OFFER](new EquipmentOffering({equipment_offering_external_id: id}))
            // this.$set(this, 'online_offer', new EquipmentOffering({equipment_offering_external_id: id}));

            // this.$set(this.quote, 'online_offer', {});
            this.getEntityOffer(id, 'online_offer');
        },
        //
        getEntityOffer: function (id, offer_type = '') {
            let vm = this;
            if (offer_type === 'online_offer') {
                this.online_is_loading = true;
            } else {
                this.equipment_is_loading = true;
            }
            const url = `/application/ajaxgetequipmentoffer/` + id;
            if (this.entityOffer_abortController) {
                this.entityOffer_abortController.abort();
            }

            this.entityOffer_abortController = new AbortController()
            this.getAxiosInstance().get(url,{
                signal: this.entityOffer_abortController.signal
            }).then(response => {
                vm.entityOffer_abortController = null;
                if (response['data']['result'] === 'SUCCESS') {
                    let offering_data = response['data']['equipment_offering'];
                    let offerObject = new EquipmentOffering(offering_data);

                    const reductionLogic = function (mapped_bundles, bundle) {
                        mapped_bundles.push(new Bundle(bundle));
                        return mapped_bundles;
                    };
                    offerObject['bundles'] = offering_data['equipment_offering_bundles'].reduce(reductionLogic, []);
                    //only get the first bundle;
                    // offerObject['bundles'] = offerObject['bundles'].filter((obj, index) => {return index === 0})

                    if (offer_type === 'online_offer') {
                        vm.setOnlineOffer(offerObject);
                        vm.online_is_loading = false;
                    } else {
                        vm.setEquipmentOffer(offerObject);
                        vm.equipment_is_loading = false;
                    }
                } else {
                    vm.online_is_loading = false;
                    vm.equipment_is_loading = false;
                }
                vm.addValidationRules()
            }).catch(function (error) {
                console.error(error)
            })
        },
        setEquipmentOffer(offerObject) {
            let formatted_offer = {};
            if (offerObject.equipment_offering_external_id === this.quote.equipment_offer.equipment_offering_external_id) {
                formatted_offer = this.setEntityOffer(this.quote.equipment_offer, offerObject)
            } else {
                formatted_offer = this.setEntityOffer({}, offerObject);
            }

            //group the blocks
            formatted_offer['equipment_list'] = formatted_offer.bundles.find(obj => obj.individual_item_only === '1');
            formatted_offer['bundle_packages'] = formatted_offer.bundles.filter(obj => obj.individual_item_only === '0'); //for bundled equipments

            this[types.SET_EQUIPMENT_OFFER](formatted_offer)

            //dont filter by agreement in view  else it will select  items that match
            // the agreement length but weren't selected
            if (!this.is_view) {
                this.filterByAgreementLength()
            }
        },
        setOnlineOffer: function (offerObject){
            let formatted_offer = {};
            if (offerObject.equipment_offering_external_id === this.quote.online_offer.equipment_offering_external_id) {
                formatted_offer = this.setEntityOffer(this.quote.online_offer, offerObject)
            } else {
                formatted_offer = this.setEntityOffer({}, offerObject);
            }
            // let formatted_offer = this.setEntityOffer(this.quote.online_offer, offerObject)

            formatted_offer['equipment_list'] = formatted_offer.bundles.find(obj => obj.individual_item_only === '1');

            this[types.SET_ONLINE_OFFER](formatted_offer)

        },
        prepareItemsDictionary: function (quoteOffer) {
            let vm = this, selectedItemsDictionary = {};
            if (vm.objectIsNotEmpty(quoteOffer) && vm.objectIsNotEmpty(quoteOffer.bundles)) {
                quoteOffer.bundles.forEach(bundle => {
                    selectedItemsDictionary[bundle.equipment_bundle_external_id] = {id: bundle.equipment_bundle_external_id, 'bundle_items': {}};
                    if (!!bundle.bundle_items) {
                        bundle.bundle_items.forEach(bundle_item => {
                            selectedItemsDictionary[bundle.equipment_bundle_external_id]['bundle_items'][bundle_item.equipment_bundle_item_external_id] = {
                                terminal_quantity: bundle_item.terminal_quantity,
                                terminal_unit_price: bundle_item.terminal_unit_price,
                                is_boarding_activated: bundle_item.is_boarding_activated,
                                equipment_features: {},
                                service_features: {},
                                service_charges: {}
                            };
                            if (bundle_item.hasOwnProperty('equipment_features')
                                && vm.objectIsNotEmpty(bundle_item.equipment_features)) {
                                bundle_item.equipment_features.forEach(feature => {
                                    selectedItemsDictionary[bundle.equipment_bundle_external_id]['bundle_items'][bundle_item.equipment_bundle_item_external_id]['equipment_features'][feature.feature_external_id] = feature;
                                })
                            }
                            if (bundle_item.hasOwnProperty('service_features')
                                && vm.objectIsNotEmpty(bundle_item.service_features)) {
                                bundle_item.service_features.forEach(feature => {
                                    selectedItemsDictionary[bundle.equipment_bundle_external_id]['bundle_items'][bundle_item.equipment_bundle_item_external_id]['service_features'][feature.feature_external_id] = feature;
                                })
                            }
                            if (bundle_item.hasOwnProperty('service_charges')
                                && vm.objectIsNotEmpty(bundle_item.service_charges)) {
                                bundle_item.service_charges.forEach(charge => {
                                    selectedItemsDictionary[bundle.equipment_bundle_external_id]['bundle_items'][bundle_item.equipment_bundle_item_external_id]['service_charges'][charge.service_charge_item_external_id] = charge;
                                })
                            }
                        });
                    }
                })
            }
            return selectedItemsDictionary;
        },
        setEntityOffer: function(quoteOffer, offerObject){
            let vm = this;
            let selectedItemsDictionary = vm.prepareItemsDictionary(quoteOffer);
            // Create dictionary of selected items;
            offerObject.bundles.forEach(bundle => {

                //show selected bundle packages
                if (selectedItemsDictionary.hasOwnProperty(bundle.equipment_bundle_external_id)) {
                    bundle.selected = '1';
                    bundle.is_boarding_activated = '1';
                }
                    bundle.bundle_items.forEach(bundle_item => {
                        let matched_bundle_item;
                        //match already selected equipments
                        if (selectedItemsDictionary.hasOwnProperty(bundle.equipment_bundle_external_id)
                            && selectedItemsDictionary[bundle.equipment_bundle_external_id]['bundle_items'].hasOwnProperty(bundle_item.equipment_bundle_item_external_id)) {
                            matched_bundle_item = selectedItemsDictionary[bundle.equipment_bundle_external_id]['bundle_items'][bundle_item.equipment_bundle_item_external_id];
                        }

                        //set values from matched item
                        if (!!matched_bundle_item) {
                            // set the bundle to selected
                            bundle_item.terminal_quantity = parseInt(matched_bundle_item.terminal_quantity);
                            bundle_item.terminal_unit_price = matched_bundle_item.terminal_unit_price;
                            bundle_item.selected = true;
                            bundle_item.is_boarding_activated = '1';
                            bundle_item.display = bundle_item.is_invisible === '0';
                        }else{
                            if (this.isEquipment(bundle_item) || this.isAccessory(bundle_item)) { //hide unmatched equipment and accessories. filterByAgreementLength will show them if they match the right billing plan
                                bundle_item.display = false; //fix £0 pricing on non-selected terminals with the right billing plan when you open terminal on review and then go to edit page
                            }
                        }

                        //TODO somehow mandatory items are not selected true on the fresh selection that's what caused
                        //TODO ELV 697

                        //on the view page, only matched bundle items (what has been saved) should show, we don't care if config says it's mandatory
                        if ((bundle_item.is_mandatory === '1' || bundle_item.mandatory === '1') && !this.is_view) {
                            bundle_item.selected = true;
                            bundle_item.is_boarding_activated = '1';
                            bundle_item.terminal_quantity = 1;
                            bundle_item.display = true;
                        }
                        if (bundle_item.is_invisible === '1'){
                            bundle_item.display = false;
                        }
                        if (bundle_item.hasOwnProperty('equipment_features')
                            && vm.objectIsNotEmpty(bundle_item.equipment_features)) {
                            bundle_item.equipment_features.forEach(feature => {

                                feature.value = '';
                                feature.selected = '';
                                //set values from matched item
                                if (!!matched_bundle_item
                                    && matched_bundle_item.hasOwnProperty('equipment_features')
                                    && matched_bundle_item.equipment_features.hasOwnProperty(feature.feature_external_id)) {
                                    feature['selected'] = matched_bundle_item.equipment_features[feature.feature_external_id]['selected'];
                                    feature['value'] = matched_bundle_item.equipment_features[feature.feature_external_id]['value'];
                                }
                                feature.is_visible = feature.merchant_visibility === '1';
                                feature.is_selectable = feature.control_level_type === 'VARIABLE_FOR_ALLIANCE' && feature.is_visible;
                            })
                        }

                        if (bundle_item.hasOwnProperty('service_features')
                            && vm.objectIsNotEmpty(bundle_item.service_features)) {
                            bundle_item.service_features.forEach(feature => {
                                feature.value = '';
                                feature.selected = '';
                                //set values from matched item
                                //TODO there is some limitation
                                //TODO if the service has new features they won't get selected. Logic has been written Okhae check your notes 16-10-2020
                                if (!!matched_bundle_item
                                    && matched_bundle_item.hasOwnProperty('service_features')
                                    && matched_bundle_item.service_features.hasOwnProperty(feature.feature_external_id)) {
                                    feature['selected'] = matched_bundle_item.service_features[feature.feature_external_id]['selected'];
                                    feature['value'] = matched_bundle_item.service_features[feature.feature_external_id]['value'];
                                }else{
                                    //!!! shouldn't use for Additional Options.
                                    //set the value based on the collect_on_boarding flag.
                                    if (bundle_item.is_boarding_activated === '1' && bundle_item.is_invisible === '1') {
                                        if (feature.collect_on_boarding === this.collect_on_boarding_types.OFFER || feature.collect_on_boarding === this.collect_on_boarding_types.CONFIG) {
                                            feature['value'] = feature.hasOwnProperty('collect_on_value') ? feature.collect_on_value : feature.default_value;
                                            feature['disabled'] = true; //user can't change the selection
                                            feature.selected = bundle_item.is_boarding_activated === '1' && feature.is_required === '1' ? '1' : '0'; //if feature is required on boarding then it's selected
                                        }
                                    }
                                }
                                feature.is_visible = feature.merchant_visibility === '1';
                                feature.is_selectable = feature.control_level_type === 'VARIABLE_FOR_ALLIANCE' && feature.is_visible;
                            })
                        }

                        if (bundle_item.hasOwnProperty('service_charges')
                            && vm.objectIsNotEmpty(bundle_item.service_charges)) {
                            bundle_item.service_charges.forEach(charge => {
                                //set values from matched item
                                if (!!matched_bundle_item
                                    && matched_bundle_item.hasOwnProperty('service_charges')
                                    && matched_bundle_item.service_charges.hasOwnProperty(charge.service_charge_item_external_id)) {
                                    charge['selected'] = matched_bundle_item.service_charges[charge.service_charge_item_external_id]['is_selected'];
                                    charge['service_base_charge'] = matched_bundle_item.service_charges[charge.service_charge_item_external_id]['service_base_charge'];
                                    charge['service_perc_charge'] = matched_bundle_item.service_charges[charge.service_charge_item_external_id]['service_perc_charge'];
                                }else{
                                    //set the service_charges
                                    charge['service_base_charge'] = !!charge['default_base_charge'] ? charge['default_base_charge'] : charge['maximum_base_charge'];
                                    charge['service_perc_charge'] = !!charge['default_perc_charge'] ? charge['default_perc_charge'] : charge['maximum_perc_charge'];
                                }
                            })
                        }

                        //is service is faster payments, check the bank
                        if (vm.isGeneralService(bundle_item) && bundle_item.service.service_type === FASTER_PAYMENT){
                            let banks = this.npPropertyExistAndIsArray(this.outlets[0], 'banks') ? this.outlets[0].banks : null ;

                            if (Array.isArray(banks)) {
                                let has_faster_payment_excluded_bank = banks.find(bank => {
                                    return types.FASTER_PAYMENT_EXCLUDED_BANKS.includes(bank.bank_name.toUpperCase())
                                })

                                if (!!has_faster_payment_excluded_bank) {
                                    bundle_item['is_boarding_activated'] = '2';
                                    bundle_item['is_disabled'] = '1';
                                }
                            }
                        }
                        vm.setBundleItemByCustomFeatureLogic(bundle_item)
                    });
            });

            if (this.npPropertyExistAndIsArray(offerObject, 'additional_data')){
                offerObject.additional_data = this.initEquipmentOfferAdditionalData(offerObject.additional_data)
            }
            this.setEquipmentCurrency(offerObject)
            return offerObject;
        },
        setEquipmentCurrency: function (equipment) {
            this.equipment_currency = !!equipment ? equipment.currency : '';
        },
        setOfferings($event, forceReset = false) {
            let vm = this;
            let data = vm.matched_packages[$event];
            let quote_is_acquiring_only = vm.quote.acquiring_only == '1';

            if (!!data) {

                let sort_function = (a, b) => {
                    return  parseFloat(a['order']) - parseFloat(b['order']);
                };
                let acquiring_offerings = data.hasOwnProperty('acquiring_offerings') ? data.acquiring_offerings : [];
                acquiring_offerings.sort(sort_function);
                let equipment_offerings = data.hasOwnProperty('equipment_offerings') ? data.equipment_offerings : [];
                equipment_offerings.sort(sort_function);
                let online_offerings = data.hasOwnProperty('online_offerings') ? data.online_offerings : [];
                online_offerings.sort(sort_function);
                //equipment check
                let current_equipment_offer = vm.equipment_offer.equipment_offering_external_id;
                let has_offer = false;
                equipment_offerings.forEach(obj => {
                    obj.id = obj.equipment_offering_external_id;
                    obj.text = obj.offering_name;

                    if (!!current_equipment_offer && obj.equipment_offering_external_id === current_equipment_offer) {
                        has_offer = true;
                    }
                });
                if (!has_offer || forceReset) {
                    vm[types.SET_EQUIPMENT_OFFER](new EquipmentOffering());
                }

                if (equipment_offerings.length === 1 && equipment_offerings[0]['id'] !== vm.equipment_offer.equipment_offering_external_id) {
                    // quote_is_acquiring_only is the acquiring flag of the requested criteria
                    // if '1', equipment offer must be acquiring only.
                    // if '0', equipment offer must be non-acquiring-only.
                    // if not '0' and not '1', this means the merchant did not select or we did not config it, equipment offer can be both.
                    if ((quote_is_acquiring_only === '1' && equipment_offerings[0].acquiring_only == '1')
                        || (quote_is_acquiring_only === '0' && equipment_offerings[0].acquiring_only != '1')
                        || (quote_is_acquiring_only !== '0' && quote_is_acquiring_only !== '1')
                    ) {
                        vm.equipment_offer.equipment_offering_external_id = equipment_offerings[0]['id'];
                        vm.getEquipmentOffer(vm.equipment_offer.equipment_offering_external_id)
                    }
                }

                online_offerings.forEach(obj => {
                    obj.id = obj.equipment_offering_external_id;
                    obj.text = obj.offering_name;
                });

                if (online_offerings.length === 1) {
                    // quote_is_acquiring_only is the acquiring flag of the requested criteria
                    // if '1', offer must be acquiring only.
                    // if '0', offer must be non-acquiring-only.
                    // if not '0' and not '1', this means the merchant did not select or we did not config it, the offer can be both.
                    if ((quote_is_acquiring_only === '1' && online_offerings[0].acquiring_only == '1')
                        || (quote_is_acquiring_only === '0' && online_offerings[0].acquiring_only != '1')
                        || (quote_is_acquiring_only !== '0' && quote_is_acquiring_only !== '1')
                    ) {
                        vm.online_offer.equipment_offering_external_id = online_offerings[0]['id'];
                        vm.getOnlineOffer(vm.online_offer.equipment_offering_external_id);
                    }
                }

                acquiring_offerings.forEach(obj => {
                    obj.id = obj.transaction_pricing_external_id;
                    obj.text = obj.offering_name;
                });

                vm[types.EQUIPMENT_OFFERING](equipment_offerings);
                vm[types.ACQUIRING_OFFERING](acquiring_offerings);
                vm[types.ONLINE_OFFERING](online_offerings)
            }
            else {
                //even if there is no match in the offer package list, e.g. offer is AB only, still needs to be shown
                if (vm.objectIsNotEmpty(vm.quote.equipment_offer)) {
                    vm.getEquipmentOffer(vm.quote.equipment_offer.equipment_offering_external_id);
                }
                else if (vm.objectIsNotEmpty(vm.quote.online_offer)) {
                    vm.getOnlineOffer(vm.quote.online_offer.equipment_offering_external_id);
                }
            }
        },
        initEquipmentOfferAdditionalData: function (additional_data){
            let vm = this, additional_data_params = [];
            let attributes = [];

            if (this.parameters.hasOwnProperty('ADDITIONAL_DATA_PARAM')) {
                additional_data_params = this.parameters.ADDITIONAL_DATA_PARAM.filter(obj => {
                    if (this.quote.payment_method === this.payment_method.PAYMENT_METHOD_F2F_ONLY) {
                        return obj.belongs_to === this.additional_data_belong_to_list.ADDITIONAL_DATA_BELONGS_TO_EQUIPMENT_OFFERING
                    } else {
                        return obj.belongs_to === this.additional_data_belong_to_list.ADDITIONAL_DATA_BELONGS_TO_ONLINE_OFFERING
                    }
                })
            }

            //Saved Records in the acquiring offer configurations
            let saved_records_in_config =  {};
            if (!!additional_data) {
                additional_data.forEach(record => {
                    //keyed by additional_attribute_external_id (select2), value is additional_record_external_id (select2 option);
                    saved_records_in_config[record['additional_attribute_external_id']] = record['additional_record_external_id'];
                });
            }

            if (additional_data_params.length > 0){
                additional_data_params.forEach(obj => {
                    let attribute = obj;
                    if (attribute.hasOwnProperty('category_name')) {
                        attribute['parameters'] = [];
                        attribute['parameter_list'] = [];
                        if (vm.npPropertyExistAndIsArray(obj, 'additional_records')) {
                            obj.additional_records.forEach(record => {
                                //use the parameter value saved by acquiring offer config
                                if (saved_records_in_config.hasOwnProperty(attribute['additional_attribute_external_id'])
                                    && record['additional_record_external_id'] === saved_records_in_config[attribute['additional_attribute_external_id']]) {
                                    record['id'] = record['additional_record_external_id'];
                                    record['text'] = record['record_name'];
                                    if (obj.has_parent_entity === '1') {
                                        attribute['parameter_list'].push(record);
                                    } else {
                                        attribute['parameters'].push(record);
                                    }

                                    attribute.additional_record_external_id = saved_records_in_config[attribute['additional_attribute_external_id']];
                                }
                            });
                        }

                        if (attribute['parameters'].length === 1) {
                            attribute['additional_record_external_id'] = attribute['parameters'][0]['id'];
                        }

                        if (attribute['parameters'].length > 0 || attribute['parameter_list'].length > 0) {
                            attributes.push(attribute);
                        }
                    }
                })
            }

            attributes.forEach(parent => {
                vm.setChildParameter(attributes, parent);
            });
            return attributes;
        },
        setChildParameter: function (additional_data, parent) {
            let vm = this;
            if (parent.has_parent_entity != '1') {
                additional_data.forEach((datum, d_index) => {
                    if (datum.has_parent_entity === '1'
                        && (datum.parent_entity_id === parent['additional_attribute_external_id'])
                        && (!!parent.additional_record_external_id && parent.additional_record_external_id !== '')) {
                        let child_parameters = datum['parameter_list'].filter(obj => {
                            return parent.additional_record_external_id === obj.parent_additional_record_external_id;
                        });
                        if (child_parameters.length === 1) {
                            additional_data[d_index]['additional_record_external_id'] = child_parameters[0]['id'];
                        }
                        additional_data[d_index]['update_key'] = Math.random();
                        additional_data[d_index]['parameters'] = child_parameters;
                        vm.$forceUpdate();
                    }
                })
            }
        },
    },
    watch: {
        'matched_packages': {
            immediate: true,
            handler: function(val) {
                let vm = this;
                if (!!val){
                    vm.packageList = vm.setPackageList();
                }
            }
        }
    }
}